import { FormEvent, useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Nav from 'react-bootstrap/Nav'
import ProgressBar from 'react-bootstrap/ProgressBar'

import Card from '@/components/Card/Card'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import Panel from '@/components/Panel/Panel'
import PleaseSupportUs from '@/components/PleaseSupportUs/PleaseSupportUs'
import Spinner from '@/components/Spinner/Spinner'
import { RecsPageCardType } from '@/types/recs'
import { scrollToTop } from '@/utils/helpers'
import { formatUrl } from '@/utils/helpers'
import usePatreonTier from '@/utils/usePatreonTier'

import styles from './RecsResults.module.scss'

type Props = {
  canLoadMore: boolean
  inRecs: RecsPageCardType[]
  isLoading: boolean
  onBack: () => void
  onLoadMore: (e: FormEvent<HTMLFormElement>) => void
  outRecs: RecsPageCardType[]
}

const RecsResults = ({ canLoadMore, inRecs, isLoading, onBack, onLoadMore, outRecs }: Props) => {
  const patreonTier = usePatreonTier()
  const [key, setKey] = useState('in')

  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <Panel>
      <div className='mb-3'>
        <div className='d-flex align-items-center flex-column text-center'>
          {key === 'in' ? (
            <span>Sorted by recommendation strength</span>
          ) : (
            <span>
              Sorted by <i>unpopularity</i>
            </span>
          )}
          <span>Scores ranges may vary based on input</span>
        </div>
      </div>
      <div className={styles.header}>
        <Button className={styles.back} onClick={onBack} variant='secondary'>
          Go Back
        </Button>
        <Nav activeKey={key} className={styles.right} onSelect={(k) => setKey(k as string)} variant='pills'>
          <Nav.Item>
            <Nav.Link eventKey='in'>Recommendations</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey='out'>Cuts</Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      <div className={styles.body}>
        <div className={styles.grid}>
          {(key === 'in' ? inRecs : outRecs).map((cardview: any) => (
            <Card
              card={{ ...cardview, url: `/cards/${formatUrl(cardview.name)}` }}
              key={cardview.name}
              label={<ProgressBar className={styles.bar} label={cardview.score} now={cardview.score} striped />}
            />
          ))}
        </div>
        {key === 'in' &&
          (patreonTier !== 'rare' ? (
            <PleaseSupportUs always className='d-flex flex-column my-2' rare>
              <div className='d-flex flex-column gap-3'>
                <div className='d-flex justify-content-center'>
                  <Button disabled>Load More</Button>
                </div>
                <div className='d-flex justify-content-center'>
                  <OutboundLink url='https://patreon.com/edhrec' utm_medium='recs_load_more'>
                    Become a Rare Patron for $5/month to unlock this feature.
                  </OutboundLink>
                </div>
              </div>
            </PleaseSupportUs>
          ) : (
            canLoadMore && (
              <form className='d-flex m-1 justify-content-center w-100' onSubmit={onLoadMore}>
                <Button type='submit'>{isLoading ? <Spinner /> : 'Load More'}</Button>
              </form>
            )
          ))}
      </div>
    </Panel>
  )
}

export default RecsResults
